import Crumb from './Crumb';

export default function OtherBreadcrumb({ item, currentPath }) {
  return <Crumb currentPath={currentPath} item={item} />;
}
